import { pushRoute } from '../../../lib/router.js';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import {
  DragDropContext,
  Draggable,
  Droppable,
  resetServerContext,
} from 'react-beautiful-dnd';
import { getOrgTermsContent } from '../../../content/utils.js';
import FieldGroup from '../../FieldGroup.jsx';
import { FormError } from '../../FormError.jsx';
import { CustomProjectStatusesLink } from '../../links/index.jsx';

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'none' : 'none',
});

const OrgCustomStatusesSettingForm = (props) => {
  const {
    slug,
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    onDragEnd,
    onCreateColumn,
    onDeleteColumn,
    onColumnNameChange,
    data,
  } = props;

  resetServerContext();

  const onCancel = () => {
    pushRoute('organization/custom-settings');
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom flex row">
            <h3>
              {getOrgTermsContent('project')} And{' '}
              {getOrgTermsContent('portfolio')} Statuses
            </h3>
          </div>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {data.map((item, index) => (
                    <Draggable
                      key={item.draggableId}
                      draggableId={item.draggableId}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <Row>
                            <Col xs={1}>
                              <span
                                className="btn-move btn btn-default"
                                {...provided.dragHandleProps}
                              ></span>
                            </Col>
                            <Col xs={4}>
                              <Field
                                id={item.draggableId}
                                name={item.draggableId}
                                className="m-0"
                                placeholder="Enter Title"
                                disabled={
                                  item.nativeColumn === 'influence' ||
                                  item.nativeColumn === 'interest'
                                }
                                type="text"
                                label=""
                              >
                                {(props) => (
                                  <FieldGroup
                                    {...props}
                                    value={item.name}
                                    onChange={(event) =>
                                      onColumnNameChange(
                                        event.target.value,
                                        index
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </Col>
                            <Col xs={1}>
                              <button
                                type="button"
                                disabled={!item.allowDelete}
                                className="btn-delete btn btn-default"
                                onClick={() => onDeleteColumn(item.draggableId)}
                              ></button>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
        <Col xs={12}>
          <button
            disabled={data[data.length - 1] && !data[data.length - 1].name}
            className="btn-link"
            onClick={(event) => {
              event.preventDefault();
              onCreateColumn();
            }}
          >
            {' '}
            + Create New Status
          </button>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <CustomProjectStatusesLink>
                <Button bsStyle="default" onClick={onCancel}>
                  Cancel
                </Button>
              </CustomProjectStatusesLink>
              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default OrgCustomStatusesSettingForm;
